import React from 'react';
import Sidebar from '../OneShell/Sidebar/Sidebar';
import Navbar from '../OneShell/Navbar/Navbar';

export default function HeaderSideBar({
  window,
  menuOpen,
  drawerWidth,
  setMenuOpen,
  escopoAcesso,
  setScrIframe,
  setDrawerWidth,
  setEscopoAcesso,
  onlySmallScreen,
  setUserSideBarOpen,
  handleDrawerToggle,
  qtdIconeNotificacao,
  setAlertSideBarOpen,
  departamentoSelecionado,
  setDepartamentoSelecionado
}) {
  return (
    <>
      <Navbar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        onlySmallScreen={onlySmallScreen}
        setEscopoAcesso={setEscopoAcesso}
        setUserSideBarOpen={setUserSideBarOpen}
        handleDrawerToggle={handleDrawerToggle}
        setAlertSideBarOpen={setAlertSideBarOpen}
        qtdIconeNotificacao={qtdIconeNotificacao}
        departamentoSelecionado={departamentoSelecionado}
        setDepartamentoSelecionado={setDepartamentoSelecionado}
      />

      <Sidebar
        window={window}
        menuOpen={menuOpen}
        drawerWidth={drawerWidth}
        escopoAcesso={escopoAcesso}
        setScrIframe={setScrIframe}
        setDrawerWidth={setDrawerWidth}
        onlySmallScreen={onlySmallScreen}
        setEscopoAcesso={setEscopoAcesso}
        handleDrawerToggle={handleDrawerToggle}
        departamentoSelecionado={departamentoSelecionado}
      />
    </>
  );
}
